import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { setToken, user } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log("Auth Callback: Starting authentication process");
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const redirectTo = params.get('redirectTo') || '/';
        
        console.log("Auth Callback: Received parameters", { 
          hasToken: !!token,
          redirectTo 
        });
        
        if (!token) {
          console.error("Auth Callback: No token provided");
          setError("No authentication token provided");
          return;
        }
        
        // Debug token contents
        try {
          const decoded = JSON.parse(atob(token.split('.')[1]));
          console.log("Auth Callback: Token payload", decoded);
        } catch (e) {
          console.error("Auth Callback: Error decoding token", e);
        }
        
        console.log("Auth Callback: Setting token");
        await setToken(token);
        console.log("Auth Callback: Token set, user:", user);
        
        // Wait a moment for user state to be updated
        setTimeout(() => {
          console.log("Auth Callback: Ready to navigate, user:", user);
          navigate(decodeURIComponent(redirectTo));
        }, 1000);
      } catch (error) {
        console.error("Auth Callback: Error during authentication", error);
        setError("Authentication failed");
      }
    };

    handleCallback();
  }, [navigate, setToken]);

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen">
      <p>Authenticating...</p>
    </div>
  );
};

export default AuthCallback;